import { useState } from 'react'
import { deleteBimlink as deleteBimLinkJit } from '../api/estructuraCostes/bimLinksJitApi'
import toast from 'react-hot-toast'
import { useQueryClient } from '@tanstack/react-query'

export const useDeleteBimlink = (id, setIsBimLinkInUse) => {
  const [isLoading, setIsLoading] = useState(false)
  const queryClient = useQueryClient()
  const deleteBimlink = async () => {
    setIsLoading(true)
    try {
      await deleteBimLinkJit(id)
      setIsBimLinkInUse(false)
      queryClient.invalidateQueries('bimlinks')
      toast.success('BimLink eliminado correctamente')
    } catch (e) {
      const { response } = e
      const errorCode = response?.data?.errorCode
      if (errorCode === 'BIMLINK_IN_USE') {
        setIsBimLinkInUse(response.data.tipoBimLinks)
      }
    } finally {
      setIsLoading(false)
    }
  }

  return { deleteBimlink, isLoading }
}
